const H3 = ({ children }) => {
  return (
    <h2 className="mb-4 text-base font-medium text-primary-500 lg:text-xl 2xl:text-2xl">
      <span className="bg-accent-100 px-1">{children}</span>
    </h2>
  )
}

export default H3
